<template>
  <div id="page-forms">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <template>
          <!-- TAB DE PROVEEDOR -->
          <v-card flat>
            <proveedor-tab
              :show="true"
              :tipeView="'consulta'"
              :contratoId="contratoId"
            ></proveedor-tab>
          </v-card>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DeleteProvedorModal from "@/modules/configuration/commonsviews/DeleteProveedorModal.vue";
import ProveedorTab from "@/modules/configuration/commonsviews/ProveedorTab.vue";

//Vue.use(VeeValidate);

export default {
  name: "proceso-impresion",

  components: {
    DeleteProvedorModal,
    ProveedorTab,
  },
  props: {},

  data: () => ({
    text: "En construccion",
    proveedor: {},

    contratoId: "",
    //tabSelected:''
  }),
  mounted() {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
